import React from "react";
import Button from "@amzn/meridian/button";
import "./Footer.scss";

export interface FooterProps {
  onClearOverrides: () => void;
  onNext: () => void;
  lastModified?: string;
  showClearOverrides?: boolean;
  nextButtonDisplay?: string;
}

/**
 * Reusable Footer component with Clear overrides and Next buttons
 */
const Footer: React.FC<FooterProps> = ({
  onClearOverrides,
  onNext,
  lastModified,
  nextButtonDisplay,
  showClearOverrides = true,
}) => {
  return (
    <div className="footer">
      {lastModified && <div className="last-modified">{lastModified}</div>}
      <div className="actions">
        {showClearOverrides && (
          <Button onClick={onClearOverrides}>Clear overrides</Button>
        )}
        <Button onClick={onNext}>{nextButtonDisplay || "Next"}</Button>
      </div>
    </div>
  );
};

export default Footer;
